import { AlertTriangle, CheckCircle, Info, Loader, XCircle } from "lucide-react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const isMobile = window.innerWidth < 768;
  return (
    <Sonner
      className="toaster group"
      closeButton
      toastOptions={{
        unstyled: true,
        classNames: {
          default: "rounded-md border p-3.5 text-[15px] flex gap-2 w-full",
          error: "bg-general-red-700 border-general-red-800",
          info: "bg-general-blue-400",
          success: "bg-general-mint-600 border-general-green-700",
          warning: "bg-general-orange-400",
          closeButton: "absolute right-3.5 top-3.5 [&>svg]:w-6 [&>svg]:h-6 cursor-pointer",
          title: "text-general-gray-800 font-semibold",
          description: "text-general-gray-700",
          icon: "pt-1"
        },
      }}
      icons={{
        success: <CheckCircle className="h-4 w-4 text-green-500" />,
        info: <Info className="h-4 w-4 text-blue-500" />,
        warning: <AlertTriangle className="h-4 w-4 text-amber-500" />,
        error: <XCircle className="h-4 w-4 text-red-500" />,
        loading: <Loader className="h-4 w-4 text-gray-500 animate-spin" />,
      }}
      position={isMobile ? "bottom-right" : "top-center"}
      {...props}
    />
  );
};
export default Toaster;
